import produce from "immer";
import fp from "lodash/fp";
import createCachedSelector from "re-reselect";
/* --------------------------------- imports -------------------------------- */
import { createAction, createAssign, createList } from "robodux";

// the same names are definded in uJKarmaTransferApi.pas. Change both or none//
import {
  CONST_LIST_OF_CONTACTS,
  CONST_LIST_OF_MATTERS,
  CONST_LIST_OF_MYWORK,
  CONST_LIST_OF_PERSONS,
  CONST_LIST_SS_OF_AVO,
  CONST_LIST_SS_OF_CTRDOSARE,
  CONST_LIST_SS_OF_INVOICE,
  CONST_LIST_SS_OF_PROFORMA,
  CONST_LISTORIGIN_AVOCATI,
  CONST_LISTORIGIN_CTRDOSARE,
  CONST_LISTORIGIN_INVOICE,
  CONST_LISTORIGIN_PROFORMA,
  CONST_LISTORIGIN_WORK,
  CONST_listQueryState,
  CONST_LSTORIGIN_CONTACTE,
  CONST_LSTORIGIN_PERSOANE,
} from "@app/state/insider/constants";
//
import { IDBListOfPersons, IListOfPersons } from "@app/types/insider";
import { createSelector } from "@reduxjs/toolkit";

import type { RootState } from "../rootState";
const listQueryState = CONST_listQueryState;
export const LIST_OF_CONTACTS = CONST_LIST_OF_CONTACTS; // 'listOf_contacts' as const;
export const LIST_OF_MATTERS = CONST_LIST_OF_MATTERS; //'listOf_matters' as const;
export const LIST_OF_MYWORK = CONST_LIST_OF_MYWORK; // 'listOf_mywork' as const;
export const LIST_OF_PERSONS = CONST_LIST_OF_PERSONS; // 'listOf_persons' as const;
export const LIST_OF_AVOCATI = CONST_LIST_SS_OF_AVO; // 'listOf_persons' as const;
export const LIST_OF_CTRDOSARE = CONST_LIST_SS_OF_CTRDOSARE; // 'listOf_persons' as const;
export const LIST_OF_PROFORMA = CONST_LIST_SS_OF_PROFORMA; //  'listOf_proforma' as const;
export const LIST_OF_INVOICE = CONST_LIST_SS_OF_INVOICE; //  'ss_listOf_invoice' as const;
type TListQueryState = {
  [key: string]: {
    expectRecords: number;
    hsum: string;
    subscribed: boolean;
    ctxKey?: string | null;
    criteria?: any;
  };
};

export const repo = createAssign<TListQueryState>({
  name: CONST_listQueryState,
  initialState: {
    [LIST_OF_CONTACTS]: {
      expectRecords: 0,
      hsum: "",
      subscribed: false,
      ctxKey: null,
    },
    [LIST_OF_PERSONS]: {
      expectRecords: 0,
      hsum: "",
      subscribed: false,
      ctxKey: null,
    },
    [LIST_OF_MATTERS]: {
      expectRecords: 0,
      hsum: "",
      subscribed: false,
    },
    [LIST_OF_MYWORK]: {
      expectRecords: 0,
      hsum: "",
      subscribed: false,
      ctxKey: null,
      criteria: {
        USER: {
          startsfrom: null,
          maxInterval: null,
        },
        GROUP: {
          startsfrom: null,
          maxInterval: null,
        },
      },
    },
    [LIST_OF_AVOCATI]: {
      expectRecords: 0,
      hsum: "",
      subscribed: false,
      ctxKey: null,
    },
    [LIST_OF_CTRDOSARE]: {
      expectRecords: 0,
      hsum: "",
      subscribed: false,
      ctxKey: null,
    },
    [LIST_OF_PROFORMA]: {
      expectRecords: 0,
      hsum: "",
      subscribed: false,
      ctxKey: null,
      //constant criteria from db as json key: CURRENCY_PICKER
      // could be set here too;
      criteria: ["CURRENCY_PICKER"],
    },
    [LIST_OF_INVOICE]: {
      expectRecords: 0,
      hsum: "",
      subscribed: false,
      ctxKey: null,
      criteria: [],
    },
  },
  extraReducers: {
    [`transfer/pkey/${LIST_OF_CONTACTS}`]: (state: RootState, payload: any) =>
      produce(state, (draft: any) => {
        draft[LIST_OF_CONTACTS].expectRecords = +payload.expectRecords;
        draft[LIST_OF_CONTACTS].hsum = payload.hsum;
      }),
    [`transfer/pkey/${LIST_OF_MYWORK}`]: (state: RootState, payload: any) =>
      produce(state, (draft: any) => {
        draft[LIST_OF_MYWORK].expectRecords = +payload.expectRecords;
        draft[LIST_OF_MYWORK].hsum = payload.hsum;
      }),
    [`transfer/pkey/${LIST_OF_PERSONS}`]: (state: RootState, payload: any) =>
      produce(state, (draft: any) => {
        draft[LIST_OF_PERSONS].expectRecords = +payload.expectRecords;
        draft[LIST_OF_PERSONS].hsum = payload.hsum;
      }),
    [`/poll_subscribe/${LIST_OF_CONTACTS}`]: (state: RootState, payload: any) =>
      produce(state, (draft: any) => {
        draft[LIST_OF_CONTACTS].subscribed = true;
      }),
    [`/poll_subscribe/${LIST_OF_MYWORK}`]: (state: RootState, payload: any) =>
      produce(state, (draft: any) => {
        draft[LIST_OF_MYWORK].subscribed = true;
      }),
    [`/poll_unsubscribe/${LIST_OF_CONTACTS}`]: (
      state: RootState,
      payload: any
    ) =>
      produce(state, (draft: any) => {
        draft[LIST_OF_CONTACTS].subscribed = false;
      }),
    [`/poll_unsubscribe/${LIST_OF_MYWORK}`]: (state: RootState, payload: any) =>
      produce(state, (draft: any) => {
        draft[LIST_OF_MYWORK].subscribed = false;
      }),
    [`ctxKey/${LIST_OF_CONTACTS}`]: (state: RootState, payload: any) =>
      produce(state, (draft: any) => {
        draft[LIST_OF_CONTACTS].ctxKey = payload;
      }),
    [`ctxKey/${LIST_OF_PERSONS}`]: (state: RootState, payload: any) =>
      produce(state, (draft: any) => {
        draft[LIST_OF_PERSONS].ctxKey = payload;
      }),
    [`ctxKey/${LIST_OF_MYWORK}`]: (state: RootState, payload: any) =>
      produce(state, (draft: any) => {
        draft[LIST_OF_MYWORK].ctxKey = payload;
      }),
    [`ctxKey/${LIST_OF_AVOCATI}`]: (state: RootState, payload: any) =>
      produce(state, (draft: any) => {
        draft[LIST_OF_AVOCATI].ctxKey = payload;
      }),
    [`ctxKey/${LIST_OF_CTRDOSARE}`]: (state: RootState, payload: any) =>
      produce(state, (draft: any) => {
        draft[LIST_OF_CTRDOSARE].ctxKey = payload;
      }),
    // proforma>>
    [`poll_subscribe/${LIST_OF_PROFORMA}`]: (state: RootState, payload: any) =>
      produce(state, (draft: any) => {
        draft[LIST_OF_PROFORMA].subscribed = true;
      }),
    [`poll_unsubscribe/${LIST_OF_PROFORMA}`]: (
      state: RootState,
      payload: any
    ) =>
      produce(state, (draft: any) => {
        draft[LIST_OF_PROFORMA].subscribed = false;
      }),
    [`ctxKey/${LIST_OF_PROFORMA}`]: (state: RootState, payload: any) =>
      produce(state, (draft: any) => {
        draft[LIST_OF_PROFORMA].ctxKey = payload;
      }),
    [`ctxKey/${LIST_OF_INVOICE}`]: (state: RootState, payload: any) =>
      produce(state, (draft: any) => {
        draft[LIST_OF_INVOICE].ctxKey = payload;
      }),
    // proforma<<
  },
});

export const pSubscribeListOfContacts = createAction<any>(
  `/poll_subscribe/${LIST_OF_CONTACTS}`
);
export const pUnsubscribeListOfContacts = createAction(
  `/poll_unsubscribe/${LIST_OF_CONTACTS}`
);
export const pSubscribeListOfPersons = createAction<any>(
  `/poll_subscribe/${LIST_OF_PERSONS}`
);
export const pUnsubscribeListOfPersons = createAction(
  `/poll_unsubscribe/${LIST_OF_PERSONS}`
);
export const pSubscribeListOfMywork = createAction<any>(
  `/poll_subscribe/${LIST_OF_MYWORK}`
);
export const pUnsubscribeListOfMywork = createAction(
  `/poll_unsubscribe/${LIST_OF_MYWORK}`
);
export const pRunOnceListOfMywork = createAction<any>(
  `/poll_run_once/${LIST_OF_MYWORK}`
);
export const pSubscribeListOfAvocati = createAction<any>(
  `/poll_subscribe/${LIST_OF_AVOCATI}`
);
export const pUnsubscribeListOfAvocati = createAction(
  `/poll_unsubscribe/${LIST_OF_AVOCATI}`
);
export const pSubscribeListOfCtrDosare = createAction<any>(
  `/poll_subscribe/${LIST_OF_CTRDOSARE}`
);
export const pUnsubscribeListOfCtrDosare = createAction(
  `/poll_unsubscribe/${LIST_OF_CTRDOSARE}`
);
export const pSubscribeListOfProforme = createAction<any>(
  `/poll_subscribe/${LIST_OF_PROFORMA}`
);
export const pUnsubscribeListOfProforme = createAction(
  `/poll_unsubscribe/${LIST_OF_PROFORMA}`
);
export const pSubscribeListOfInvoices = createAction<any>(
  `/poll_subscribe/${LIST_OF_INVOICE}`
);
export const pUnsubscribeListOfInvoices = createAction(
  `/poll_unsubscribe/${LIST_OF_INVOICE}`
);

//selctors
//OTHER SELECTORS:

function createParameterSelector(selector: any) {
  return (_: unknown, params: any) => selector(params);
}

const getListName = createParameterSelector(
  (params: any) => params?.list || null
);

const getSagaCache = (state: RootState) => state?.["@@saga-query/data"] || {};

export const select_lists_currentPage = (state: RootState) => state[repo.name];
export const listQueryStateSelect = (state: RootState) => state[listQueryState];
export const listQueryStateOfContactsSelect = (state: RootState) => {
  return state[listQueryState][LIST_OF_CONTACTS];
};

export const listQueryStateOfPersonsSelect = (state: RootState) => {
  return state[listQueryState][LIST_OF_PERSONS];
};

const listOf_contacts_select = (state: RootState) => state[LIST_OF_CONTACTS];
export const selectListOfContacts_old = createSelector(
  listOf_contacts_select,
  (list) => list
);

//CACHED SELECTOR:
export const listOfContactsDataset = createSelector(
  select_lists_currentPage,
  getSagaCache,
  (queryData, cache) => {
    const ctxKey = queryData[LIST_OF_CONTACTS]?.ctxKey;
    const dataset = cache?.[ctxKey] || [];
    return dataset;
  }
);

export const selectListOfPersons = createSelector(
  select_lists_currentPage,
  getSagaCache,
  (queryData, cache) => {
    const ctxKey = queryData[LIST_OF_PERSONS]?.ctxKey;
    const dataset = cache?.[ctxKey] || [];
    return dataset;
  }
);

export const selectListOfPersonsGrouped = createSelector(
  selectListOfPersons,
  (list) => {
    return fp.groupBy((x: IDBListOfPersons) => x.C_ID, list);
  }
);

const cidParam = createParameterSelector((p: any) => p?.C_ID || undefined);
// perhaps is better to use regular selector than a cached one !! (see below)

export const selectListOfPersonsByid = createCachedSelector(
  cidParam,
  selectListOfPersons,
  (cid: number, list: IListOfPersons[]) => {
    if (!cid) {
      return [];
    }
    return fp.compose(
      fp.map((item: IListOfPersons) => ({
        PRS_ID: item.PRS_ID,
        C_ID: item.C_ID,
        Identificare: `${item.NUME} ${item.PRENUME}  ${
          item.DEPARTAMENT ? `( departamentul ${item.DEPARTAMENT})` : ""
        } `,
        Contacte: `${item.LISTA_ADRESA || ""} ${item.LISTA_TELEFON || ""} ${
          item.LISTA_EMAIL || ""
        }`,
        Lista_de_corespondenta: `${item.LISTA_CORESPONDENTA || ""}`,
        Legaturi: item.LISTA_CONEXIUNE || "",
        Operantiuni: `Inserat: ${item.AVO_INSERTED || "*"} - ${
          new Date(item.DT_INSERTED).toLocaleDateString() || "*"
        };  Modificat: ${item.AVO_UPDATED || "*"} - ${
          new Date(item.DT_UPDATED).toLocaleDateString() || "*"
        }  | ${item.ARHIVAT ? "Arhivat" : "Activ"}`,
      })),
      fp.filter((item: IDBListOfPersons) => item.C_ID === cid)
    )(list);
  }
)((_, params) => params?.C_ID || undefined);

//CACHED SELECTORS

export const selectCachedMyworkList = createSelector(
  select_lists_currentPage,
  getSagaCache,
  (queryData, cache) => {
    const ctxKey = queryData[LIST_OF_MYWORK]?.ctxKey;
    return cache?.[ctxKey] || [];
  }
);

export const selectCachedContactsList = createSelector(
  select_lists_currentPage,
  getSagaCache,
  (queryData, cache) => {
    const ctxKey = queryData[LIST_OF_CONTACTS]?.ctxKey;
    const dataset = cache?.[ctxKey] || [];
    return dataset;
  }
);

export const selectCachedAvocatiList = createSelector(
  select_lists_currentPage,
  getSagaCache,
  (queryData, cache) => {
    const ctxKey = queryData[LIST_OF_AVOCATI]?.ctxKey;
    const dataset = cache?.[ctxKey] || [];
    return dataset;
  }
);

export const selectCachedCtrDosareList = createSelector(
  select_lists_currentPage,
  getSagaCache,
  (queryData, cache) => {
    const ctxKey = queryData[LIST_OF_CTRDOSARE]?.ctxKey;
    const dataset = cache?.[ctxKey] || [];
    return dataset;
  }
);

export const selectCachedProformaList = createSelector(
  select_lists_currentPage,
  getSagaCache,
  (queryData, cache) => {
    const ctxKey = queryData[LIST_OF_PROFORMA]?.ctxKey;
    const dataset = cache?.[ctxKey] || [];
    return dataset;
  }
);

export const selectCachedInvoiceList = createSelector(
  select_lists_currentPage,
  getSagaCache,
  (queryData, cache) => {
    const ctxKey = queryData[LIST_OF_INVOICE]?.ctxKey;
    const dataset = cache?.[ctxKey] || [];
    return dataset;
  }
);
export const listSwitchSelector = createCachedSelector(
  getListName,
  listOfContactsDataset,
  selectListOfPersons,
  selectCachedCtrDosareList,
  selectCachedMyworkList,
  selectCachedAvocatiList,
  selectCachedProformaList,
  selectCachedInvoiceList,
  (
    listName,
    contacte,
    persoane,
    dosare,
    work,
    avolist,
    proformalist,
    invoicelist
  ) => {
    switch (listName) {
      case CONST_LSTORIGIN_CONTACTE:
        return contacte;
      case CONST_LSTORIGIN_PERSOANE:
        return persoane;
      case CONST_LISTORIGIN_CTRDOSARE:
        return dosare;
      case CONST_LISTORIGIN_WORK:
        return work;
      case CONST_LISTORIGIN_AVOCATI:
        return avolist;
      case CONST_LISTORIGIN_PROFORMA:
        return proformalist;
      case CONST_LISTORIGIN_INVOICE:
        return invoicelist;
      default:
        return null;
    }
  }
)((_, params) => {
  return params?.list || null;
});
